import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/tw-merge';

type UiSectionProps = {
    /** The top spacing, one of the `section-pt-*` steps. */
    className?: string;
    /** Inside another block's layout: the content alone, without a frame of its own. */
    embedded?: boolean;
    children: ReactNode;
};

/** A block's frame on the page: the site container plus its top spacing. */
export function UiSection({ className, embedded = false, children }: UiSectionProps) {
    if (embedded) return children;

    return <section className={cn('site-container', className)}>{children}</section>;
}
